import { useCallback, useEffect, useState } from 'react';

// Set to true to re-enable dark mode support throughout the app.
export const DARK_MODE_ENABLED = false;

const STORAGE_KEY = 'vt_theme';

/**
 * Manages light/dark theme by toggling the 'dark' class on <html>.
 * Persists preference to localStorage under key 'vt_theme'.
 * Currently a no-op — set DARK_MODE_ENABLED = true to re-enable.
 */
const useTheme = () => {
  const [isDark, setIsDark] = useState(() => {
    if (!DARK_MODE_ENABLED) return false;
    try {
      return localStorage.getItem(STORAGE_KEY) === 'dark';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    if (!DARK_MODE_ENABLED) {
      document.documentElement.classList.remove('dark');
      return;
    }
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    try {
      localStorage.setItem(STORAGE_KEY, isDark ? 'dark' : 'light');
    } catch {}
    return () => {
      root.classList.remove('dark');
    };
  }, [isDark]);

  const toggleTheme = useCallback(() => {
    if (DARK_MODE_ENABLED) setIsDark((d) => !d);
  }, []);

  return { isDark, toggleTheme };
};

export default useTheme;
